import { resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vShow as _vShow, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, createBlock as _createBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-61e15fa2"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "choose-person-item" }
const _hoisted_2 = { class: "uf-staff-selector" }
const _hoisted_3 = ["onClick"]
const _hoisted_4 = { class: "uf-staff-selector__inner" }
const _hoisted_5 = {
  key: 0,
  style: {"margin-right":"10px"}
}
const _hoisted_6 = {
  key: 2,
  class: "uf-staff-selector__inner-avatar2"
}
const _hoisted_7 = { class: "uf-staff-selector__info" }
const _hoisted_8 = { class: "uf-staff-selector__info-name" }
const _hoisted_9 = { class: "uf-staff-selector__info-other" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_van_search = _resolveComponent("van-search")!
  const _component_van_icon = _resolveComponent("van-icon")!
  const _component_van_image = _resolveComponent("van-image")!
  const _component_van_list = _resolveComponent("van-list")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_van_search, {
      modelValue: _ctx.search_value,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.search_value) = $event)),
      shape: "round",
      placeholder: "请输入搜索关键词",
      onSearch: _ctx.onSearch
    }, null, 8, ["modelValue", "onSearch"]),
    _createVNode(_component_van_list, {
      loading: _ctx.state.loading,
      "onUpdate:loading": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.state.loading) = $event)),
      finished: _ctx.state.finished,
      "finished-text": "没有更多了",
      onLoad: _ctx.onLoad
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.state.list, (user) => {
            return (_openBlock(), _createElementBlock("div", {
              class: _normalizeClass(["uf-staff-selector__item", {
            'uf-staff-selector__item--active': _ctx.checkedIdList.includes(user.id)
          }]),
              key: user.id,
              onClick: ($event: any) => (_ctx.onClick(user))
            }, [
              _createElementVNode("div", _hoisted_4, [
                (_ctx.multiple)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                      _withDirectives(_createVNode(_component_van_icon, {
                        name: "circle",
                        color: "#CCCCCC"
                      }, null, 512), [
                        [_vShow, !_ctx.checkedIdList.includes(user.id)]
                      ]),
                      _withDirectives(_createVNode(_component_van_icon, {
                        name: "checked",
                        color: "#3d6eeb "
                      }, null, 512), [
                        [_vShow, _ctx.checkedIdList.includes(user.id)]
                      ])
                    ]))
                  : _createCommentVNode("", true),
                (user.head_pic)
                  ? (_openBlock(), _createBlock(_component_van_image, {
                      key: 1,
                      round: "",
                      width: "40px",
                      height: "40px",
                      src: user.head_pic,
                      class: "uf-staff-selector__inner-avatar"
                    }, null, 8, ["src"]))
                  : _createCommentVNode("", true),
                (!user.head_pic)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_6, _toDisplayString(user.name[0]), 1))
                  : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_7, [
                  _createElementVNode("div", _hoisted_8, _toDisplayString(user.name), 1),
                  _createElementVNode("div", _hoisted_9, _toDisplayString(user.department_name) + " - " + _toDisplayString(user.duty_name), 1)
                ])
              ])
            ], 10, _hoisted_3))
          }), 128))
        ])
      ]),
      _: 1
    }, 8, ["loading", "finished", "onLoad"])
  ]))
}